import React from 'react';
import {createRoot} from 'react-dom/client';
import {KatSpinner} from '@amzn/katal-react';

import './app/util/Logger';

import '@amzn/katal-components/styles.css';
import './assets/css/index.scss';
import AppInitWrapper from "src/app/AppInitWrapper";
import App from "src/app/App";
import {BrowserRouter} from "react-router-dom";
import {isDev} from "src/app/constant/Constants";

const container = document.getElementById('root');
const root = createRoot(container!);
if (isDev()) {
    root.render(
        <React.StrictMode>
            <AppInitWrapper>
                <React.Suspense fallback={<KatSpinner size="large"/>}>
                    <BrowserRouter>
                        <App/>
                    </BrowserRouter>
                </React.Suspense>
            </AppInitWrapper>
        </React.StrictMode>
    );
} else {
    root.render(
        <AppInitWrapper>
            <React.Suspense fallback={<KatSpinner size="large"/>}>
                <BrowserRouter>
                    <App/>
                </BrowserRouter>
            </React.Suspense>
        </AppInitWrapper>
    );
}
